export default from './TermsPage';



// WEBPACK FOOTER //
// ./src/components/Terms/index.js